/* eslint-disable no-plusplus */

/**
 * Remove chars from end of string.
 */
import WHITE_SPACES from './whitespaces';

var rtrim = function rtrim(str) {
  var chars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WHITE_SPACES;
  var end = str.length - 1;
  var charLen = chars.length;
  var found = true;
  var i;
  var c;

  while (found && end >= 0) {
    found = false;
    i = -1;
    c = str.charAt(end);

    while (++i < charLen) {
      if (c === chars[i]) {
        found = true;
        end--;
        break;
      }
    }
  }

  return end >= 0 ? str.substring(0, end + 1) : '';
};

export default rtrim;